<template>
    <b-modal
        v-model="printShow"
        size="xl"
        @shown="$_activateMap"
        header-class="custom-modal-header"
        content-class="custom-modal-content"
        dialog-class="custom-modal-dialog-print"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
    >
        <template v-slot:modal-header="{ close }">
            <h3 class="panel-header-title">
                {{ $t('printComponent.printModalTitle') }}
            </h3>
            <icon-close
                :id="'print-close'"
                @close="close()"
                class="d-inline-block float-right"
            ></icon-close>
        </template>
        <print-view
            ref="printView"
            @cancel="printShow = false"
            :map="map"
        ></print-view>
    </b-modal>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import { isMobileDevice } from '../../services/utilities/devices';

    import PrintView from './PrintView.vue';
    import IconClose from '../../components/IconClose.vue';

    export default {
        name: 'PrintModal',
        components: { 'icon-close': IconClose, 'print-view': PrintView },

        props: { map: { type: Object, required: true } },

        data() {
            return { printShow: null };
        },

        computed: { ...mapState(['showMenuPrint']) },

        watch: {
            showMenuPrint(newValue, oldValue) {
                this.printShow = newValue;
            },
            printShow(newValue, oldValue) {
                this.setShowMenuPrint(newValue);
                if (newValue) {
                    this.$store.dispatch('trackUserEvent', {
                        name: 'print',
                        stage: 'open',
                        isMobileDevice: isMobileDevice()
                    });
                }
            }
        },

        methods: {
            ...mapMutations({ setShowMenuPrint: 'SHOW_MENU_PRINT' }),
            $_activateMap() {
                this.$refs.printView.$_onStart();
            }
        }
    };
</script>

<style>
@media (min-width: 768px) and (max-width: 990px) {
    .custom-modal-dialog-print {
        max-width: 700px;
    }
}
</style>
